export default __webpack_public_path__ + "static/media/traslado-restos.6b27bfdd.svg";